var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-8"},[(_vm.title)?_c('h3',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.$slots.description)?_c('p',{staticClass:"mb-4"},[_vm._t("description")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }